import { createComponentElement } from "@modules/content/creators/createComponentElement";
import { useComponentData } from "@modules/content/hooks/useComponentData";
import { ContentComponent } from "@modules/content/types";
import { useGetContentProgress } from "@modules/content/hooks/useGetContentProgress";
import { defaultPageSize } from "@modules/content/helpers/content";
import {
  HorizontalList,
  HorizontalListItemParameters,
  HorizontalListParameters,
} from "@components/layouts/content/HorizontalList";
import { useLockedContents } from "../hooks/useLockedContent";

const Component = createComponentElement((props, ref) => {
  const {
    getParameterValues,
    getItemsParameterValues,
    contents,
    content,
    isLoading,
    isLoadingMore,
    componentData,
    uniqueId,
    getMore,
    refresh,
    meta: { hasNextPage },
  } = useComponentData<HorizontalListParameters, HorizontalListItemParameters>(
    {
      ...props,
      pageNumber: 1,
      pageSize: defaultPageSize,
    },
    ref
  );

  const {
    title,
    seeAllTitle,
    withProgress,
    newBadgeBackgroundColor,
    newBadgeShown,
    newBadgeText,
    newBadgeTextColor,
    withCompleted,
  } = getParameterValues([
    "title",
    "seeAllTitle",
    "withProgress",
    "newBadgeBackgroundColor",
    "newBadgeShown",
    "newBadgeText",
    "newBadgeTextColor",
    "withCompleted",
  ]);

  const { isLockedContent } = useLockedContents(contents || []);
  const lockedContents = isLockedContent.result;

  useGetContentProgress(
    Boolean(withProgress === "True" && contents && contents.length > 0),
    contents ? contents.map((c) => c.id ?? "") : []
  );

  return (
    <HorizontalList
      contents={contents?.map((c) => {
        const found = lockedContents?.find((l) => l.id === c.id);
        return {
          ...c,
          isLocked: found?.isLocked,
          lockType: found?.lockType,
        };
      })}
      isLoading={isLoading}
      items={getItemsParameterValues(["image"]).map((item) => {
        return {
          id: item.content.id,
          title: item.content.title,
          authors: item.content.authors,
          image: item.values.image,
        };
      })}
      onItemPress={props.onItemPress}
      parameterValues={{
        title: title || props.context?.title || "",
        seeAllTitle: seeAllTitle || "",
        withProgress: withProgress || "False",
        newBadgeBackgroundColor: newBadgeBackgroundColor || "",
        newBadgeShown: newBadgeShown || "False",
        newBadgeText: newBadgeText || "",
        newBadgeTextColor: newBadgeTextColor || "",
        withCompleted: withCompleted || "False",
      }}
    />
  );
});

export const CollectionListComponent: ContentComponent = {
  identifier: "COM:COLLECTION:LIST",
  component: Component,
};
